import { ActionType } from "@ms/uno-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for ModalStore, for use in the registry */ export const ModalStoreActionTypes = [
    ActionType.CloseModalAction,
    ActionType.OpenModalAction,
    ActionType.NavigateToView
];
